import React from "../_snowpack/pkg/react.js";
import Module from "../components/module.js";
export default function ModulePage(props) {
  return /* @__PURE__ */ React.createElement(Module, {
    ...props
  });
}
